import React from "react";
import CalculMensualiteCredit from "../components/CalculMensualiteCredit";
import { useSEO } from "../hooks/useSEO";

export default function CalculMensualiteCreditPage() {
  useSEO({
    title: "Calculateur Mensualité Crédit Immobilier Gratuit",
    description: "Calculez gratuitement votre mensualité de crédit immobilier. Simulateur précis avec tableau d'amortissement, taux d'intérêt et durée personnalisables."
  });

  return <CalculMensualiteCredit />;
}
